import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppoinmentAction,
  getAppoinmentTimeSlotAction,
  updateRejectStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import moment from "moment";
import { getDispatch, getSnackbarSuccess } from "../../../Utils/helper";
import { IS_SHOW_POPUP } from "../../../Utils/types";

export const RejectConfirmationPopup = ({
  isRejectPopup,
  setIsRejectPopup,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const [slotId, setSlotId] = useState("");
  const getAppoinmentTimeSlot = useSelector(
    (state) => state?.AppoinmentReducer?.getAppoinmentTimeSlot
  );
  useEffect(() => {
    if (isRejectPopup) {
      dispatch(
        getAppoinmentTimeSlotAction(
          isRejectPopup?.cardDetails?.appointmentId,
          isRejectPopup?.cardDetails?.valueType
        )
      );
    }
  }, [isRejectPopup]);

  const handleSubmit = async () => {
    const temp = {
      appointmentId: isRejectPopup?.cardDetails?.appointmentId,
      isApproved: "false",
      target: isRejectPopup?.cardDetails?.valueType,
      remarks: remark,
      timeSlot: moment(isRejectPopup?.cardDetails?.appointmentDateTime).format(
        "YYYY-MM-DD hh:mm A"
      ),
      validate: false,
      availableTimeSlots: slotId?.numbers?.toString(),
      AppointmentStatusId: isRejectPopup?.cardDetails?.appointmentstatusid,
    };
    if (remark === "" && slotId === "") {
      getSnackbarSuccess(
        "info",
        "please enter reason for cancellation or suggest other time slot",
        dispatch
      );
    } else if (slotId?.numbers?.length > 3) {
      getSnackbarSuccess(
        "info",
        "You can select Maximum 3 Time Slots.",
        dispatch
      );
    } else {
      await dispatch(updateRejectStatusAction(temp));
      await dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams }));
      await handleClose();
    }
  };

  const handleClose = () => {
    getDispatch(IS_SHOW_POPUP, false, dispatch);
    setIsRejectPopup(null);
    setRemark("");
    setSlotId("");
  };
  return (
    <div className="modal-body">
      <div className="approval-msg">
        <h2 className="popup-title">
          Are you sure you want to cancel the booking?
        </h2>
        <button
          type="button"
          className="btn-close normal-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>
      <div className="reject-remark">
        <div className="scheduled-timing">
          <div className="font-bold scheduled-title mt-3 mb-3">
            Suggest other time slot, you can select maximum 3 slots.
          </div>
          <div className="fixed-scroll">
            <Formik initialValues={{ numbers: "" }}>
              {({ values }) => {
                setSlotId(values?.numbers?.length ? values : "");
                return (
                  <form className="d-flex gap-10 flex-wrap">
                    {getAppoinmentTimeSlot?.length ? (
                      getAppoinmentTimeSlot?.map((ele, index) => (
                        <div
                          key={index}
                          className="__appoinment_pill-highlighted"
                          style={{ display: "flex" }}
                        >
                          <Field
                            type="checkbox"
                            name="numbers"
                            key={ele?.timeSlotId.toString()}
                            value={ele?.timeSlotId.toString()}
                            disabled={remark !== ""}
                          />
                          &nbsp;
                          {ele?.startTime} - {ele?.endTime}
                        </div>
                      ))
                    ) : (
                      <p style={{ color: "#f60000", fontWeight: "500" }}>
                        No time slot available
                      </p>
                    )}
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
        <div className="exception mt-4">
          <h3 className="shake mb-3">
            Or, please specify the reason of cancellation
          </h3>
          <textarea
            name=""
            id=""
            cols="30"
            rows="10"
            className="textarea_appoinment"
            placeholder="Type Something here.."
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            disabled={slotId !== ""}
          ></textarea>
        </div>
      </div>
      <div className="approval-btn popup-btn reject-popup-btn">
        <button
          type="button"
          aria-label="Close"
          className="approve-popup-btn"
          onClick={handleSubmit}
        >
          Yes
        </button>
        <button
          type="button"
          className="reject-popup-btn"
          aria-label="Close"
          onClick={handleClose}
        >
          No
        </button>
      </div>
    </div>
  );
};
